module.exports = __webpack_public_path__ + "img/矩形 30 拷贝 2@2x.ad3fe7f9.png";